// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-header {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #02b920 !important;
  color: white;
}

.take-assessment {
  background-color: #0b56ae !important;
  color: white !important;
}

.pagination-button {
  transform-origin: center;
  margin: 0px;
  height: 40px;
  display: flex;
  background-color: white;
}

.blur-bg {
  filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.info-bar {
  position: sticky;
  top: 0;
  z-index: 1020;
  padding: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #7ac7ff;
  background-color: #fafcff;
}

.info-card {
  padding: 5px;
  margin: 5px;
  color: #3f88e4;
  width: auto;
  background-color: #fff;
  border: 1px solid #eaecf0;
}

.marksWeightage {
  margin: 0px;
  padding: 0px;
  color: #0b56ae;
  background-color: #e3ecf6;
}

.option-card {
  margin: 10px;
  padding: 10px;
  width: 200px;
  height: auto;
  background-color: #fff;
  border: 1px solid #c2c9d1;
}`, "",{"version":3,"sources":["webpack://./../assessment/src/pages/AssessmentTaking/AssessmentTaking.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;AACF;;AAEA;EACE,oCAAA;EACA,uBAAA;AACF;;AAEA;EACE,wBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,MAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;AACF","sourcesContent":[".logo-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #02b920 !important;\n  color: white;\n}\n\n.take-assessment {\n  background-color: #0b56ae !important;\n  color: white !important;\n}\n\n.pagination-button {\n  transform-origin: center;\n  margin: 0px;\n  height: 40px;\n  display: flex;\n  background-color: white;\n}\n\n.blur-bg {\n  filter: blur(5px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.info-bar {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n  padding: 10px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid #7ac7ff;\n  background-color: #fafcff;\n}\n\n.info-card {\n  padding: 5px;\n  margin: 5px;\n  color: #3f88e4;\n  width: auto;\n  background-color: #fff;\n  border: 1px solid #eaecf0;\n}\n\n.marksWeightage {\n  margin: 0px;\n  padding: 0px;\n  color: #0b56ae;\n  background-color: #e3ecf6;\n}\n\n.option-card {\n  margin: 10px;\n  padding: 10px;\n  width: 200px;\n  height: auto;\n  background-color: #fff;\n  border: 1px solid #c2c9d1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
